import { useNovaApi } from 'novaApi/useNovaApi';

export const useContentTiersSelect = (songUuid?: string) => {
  return (
    useNovaApi<Nl.Api.ContentTiersSelectResponse>('/content_tier/select', {
      query: { song: songUuid },
    }).data?.content_tiers || []
  );
};
